(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9234,5945,9379],{

/***/ 11917:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[userId]",
      function () {
        return __webpack_require__(75872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    list-style-type: none;\n    font-size: ",
        "px;\n    padding-left: ",
        "px;\n\n    li + li {\n      margin-top: ",
        "px;\n    }\n\n    li {\n      position: relative;\n\n      p {\n        word-break: keep-all;\n      }\n\n      &:before {\n        content: '\xb7';\n        position: absolute;\n        top: -1px;\n        left: -12px;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var listCSS = function(fontSize, margin) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), fontSize, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, margin);
};
var _obj;
var DottedListSize = (_obj = {}, _defineProperty(_obj, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.small */ .u8.small, {
    fontSize: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.xsmall */ .TS.xsmall,
    margin: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxsmall */ .Ki.xxsmall
}), _defineProperty(_obj, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.medium */ .u8.medium, {
    fontSize: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .FontSizes.small */ .TS.small,
    margin: chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xhsmall */ .Ki.xhsmall
}), _obj);
var DottedList = function(param) {
    var className = param.className, items = param.items, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.medium */ .u8.medium : _size;
    var _size1 = DottedListSize[size], fontSize = _size1.fontSize, margin = _size1.margin;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
        css: listCSS(fontSize, margin),
        className: className,
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                        className: "dot"
                    }),
                    typeof item === "string" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                        className: "multiline",
                        children: item
                    }) : item
                ]
            }, "dotted-list-".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DottedList);


/***/ }),

/***/ 73686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FullscreenModalButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71618);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
/* harmony import */ var _layout_Push__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23516);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38945);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(0);\n          visibility: visible;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(100%);\n          visibility: hidden;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    height: 100%;\n    background-color: ",
        ";\n    transition: 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n    will-change: transform;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  z-index: 9;\n  width: 100%;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    justify-content: space-between;\n    padding: 0 ",
        "px;\n    height: ",
        "px;\n    ",
        "\n\n    h4 {\n      text-align: center;\n      line-height: ",
        "px;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 100%;\n    max-height: inherit;\n    overflow: auto;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  z-index: 9;\n  ",
        "\n\n  @media (max-height: 340px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








var fullscreenModalCSS = function(isOpen) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject2(), theme.var.white, isOpen ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject1()));
    };
};
var headerWrapperCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject3(), theme.var.white, (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top"));
};
var headerCSS = function(isHideHeaderBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_HEADER_HEIGHT */ .PV, !isHideHeaderBorder && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject4(), theme.border.light), _styles_css__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_HEADER_HEIGHT */ .PV);
    };
};
var headerLeftButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small);
var headerCloseButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small);
var contentCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject8(), theme.var.white);
};
var FullscreenModal = function(_param) {
    var title = _param.title, children = _param.children, leftButton = _param.leftButton, rightButton = _param.rightButton, renderButton = _param.renderButton, _hideHeaderBorder = _param.hideHeaderBorder, hideHeaderBorder = _hideHeaderBorder === void 0 ? false : _hideHeaderBorder, className = _param.className, rest = _objectWithoutProperties(_param, [
        "title",
        "children",
        "leftButton",
        "rightButton",
        "renderButton",
        "hideHeaderBorder",
        "className"
    ]);
    var open = rest.open, onClose = rest.onClose;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, rest), {
        blocking: false,
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: fullscreenModalCSS(open),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("header", {
                    css: headerWrapperCSS,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                        css: headerCSS(hideHeaderBorder),
                        children: [
                            leftButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                css: headerLeftButtonCSS,
                                children: leftButton(theme.var.black)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h4", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                css: headerCloseButtonCSS,
                                children: rightButton ? rightButton(theme.var.black) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
                                    className: "icon-btn",
                                    type: "button",
                                    onClick: function() {
                                        return onClose();
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Close */ .x8,
                                        color: theme.var.black
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                    css: contentCSS,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            top: true,
                            size: _layout_Push__WEBPACK_IMPORTED_MODULE_3__/* .PushSize.header */ .z.header
                        }),
                        children,
                        renderButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            bottom: true,
                            size: _layout_Push__WEBPACK_IMPORTED_MODULE_3__/* .PushSize.bottomButton */ .z.bottomButton
                        })
                    ]
                }),
                renderButton === null || renderButton === void 0 ? void 0 : renderButton()
            ]
        })
    }));
};
/** Button */ var fullscreenModalButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium));
var FullscreenModalButton = function(param) {
    var className = param.className, text = param.text, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        css: fullscreenModalButtonCSS,
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            text: text,
            disabled: disabled,
            onClick: onClick
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullscreenModal);


/***/ }),

/***/ 83170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _DottedList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10379);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px;\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n\n  h5 {\n    margin-bottom: ",
        "px;\n  }\n\n  p {\n    ",
        "\n  }\n\n  * + * {\n    margin-top: ",
        "px;\n  }\n\n  & + & {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var boxCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.medium */ .wU.medium, theme.var.gray50, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Typography.body14 */ .ZT.body14, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium);
};
var RestrictionInfo = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face1 */ .V6,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("정상")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t("채티 서비스 정책을 잘 지키는 채티즈 \uD83D\uDE06")
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face2 */ .JY,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("주의")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('채티는 이용자 누구든지 실수할 수 있고 고의로 정책을 위반했다고 생각하지 않습니다. 첫 위반시에는 계정에 "주의" 상태를 부여합니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"주의" 상태는 7일 동안 계정에 유지됩니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"주의" 상태는 신규 콘텐츠 발행에 영향을 주지 않습니다.')
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face3 */ .G_,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("1차 경고")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('채티 계정에 "주의" 상태가 유지되는 동안, 다시 정책을 위반하게 되면 "1차 경고" 상태를 부여합니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"1차 경고" 상태는 30일 동안 유지됩니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"1차 경고" 상태는 3일 동안 신규 콘텐츠 발행이 중지되며 아래와 같은 작업을 할 수 없습니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_DottedList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        items: [
                            t("작품 수정"),
                            t("회차 발행 (비공개 → 공개)"),
                            t("커뮤니티 게시글 생성 및 수정"),
                            t("댓글 작성"),
                            t("답글 작성"), 
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('3일이 지나면 신규 콘텐츠 발행 권한을 다시 회복하지만, 30일 동안 "1차 경고" 상태는 유지됩니다.')
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face4 */ .rR,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("2차 경고")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('채티 계정에 "1차 경고" 상태가 유지되는 동안, 다시 정책을 위반하게 되면 "2차 경고" 상태를 부여합니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"2차 경고" 상태는 30일 동안 유지됩니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"2차 경고" 상태는 7일 동안 신규 콘텐츠 발행이 중지되며 아래와 같은 작업을 할 수 없습니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_DottedList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        items: [
                            t("작품 수정"),
                            t("회차 발행 (비공개 → 공개)"),
                            t("커뮤니티 게시글 생성 및 수정"),
                            t("댓글 작성"),
                            t("답글 작성"), 
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('7일이 지나면 신규 콘텐츠 발행 권한을 다시 회복하지만, 30일 동안 "2차 경고" 상태는 유지됩니다.')
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face5 */ .HB,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("3차 경고")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('채티 계정에 "2차 경고" 상태가 유지되는 동안, 다시 정책을 위반하게 되면 "3차 경고" 상태를 부여합니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"3차 경고" 상태는 30일 동안 유지됩니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('"3차 경고" 상태는 30일 동안 신규 콘텐츠 발행이 중지되며 아래와 같은 작업을 할 수 없습니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_DottedList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        items: [
                            t("작품 수정"),
                            t("회차 발행 (비공개 → 공개)"),
                            t("커뮤니티 게시글 생성 및 수정"),
                            t("댓글 작성"),
                            t("답글 작성"), 
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('30일이 지나면 신규 콘텐츠 발행 권한을 다시 회복하지만, 30일 동안 "3차 경고" 상태는 유지됩니다.')
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                css: boxCSS,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("h5", {
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Face6 */ .vM,
                                size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.large */ .u8.large
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                                children: t("4차 경고")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t('채티 계정에 "3차 경고" 상태가 유지되는 동안, 다시 정책을 위반하게 되면 "4차 경고" 상태를 부여합니다.')
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                        className: "multiline",
                        children: t("4차 경고를 받으면 계정이 즉시\xa0정지\xa0됩니다.")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RestrictionInfo);


/***/ }),

/***/ 14054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55277);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Seo = function(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpreadProps(_objectSpread({}, props), {
        title: "".concat(title, " - ").concat(t("채티"))
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54909);
/* harmony import */ var _hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80786);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38945);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34270);
/* harmony import */ var _components_common_Pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39753);
/* harmony import */ var _components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95833);
/* harmony import */ var _api_community__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1385);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45432);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30259);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97033);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45874);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96261);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81946);
/* harmony import */ var _Post__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23468);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px;\n  button {\n    box-shadow: none;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: ",
        "px;\n  font-weight: 600;\n  flex: 1 1 0px;\n  height: 48px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




















var writeButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Spacing.medium */ .Ki.medium);
var userButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Radius.medium */ .wU.medium);
var PostList = function(param) {
    var userId = param.userId, isMyPage = param.isMyPage;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_16__/* .useWebView */ .B9)().web;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_12__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_13__/* .useUserMarketItemInventory */ .wg)(userId), data = ref.data, getDecoration = ref.getDecoration;
    var profileBtnDecoration = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_11__/* .MarketItemType.profileBtn */ .q9.profileBtn);
    var queryKey = _constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.POST.USER_LIST */ .U7.POST.USER_LIST(userId);
    var query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_15__/* .usePaginationQuery */ .Zl)(queryKey, function(param) {
        var pageParam = param.pageParam;
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_10__/* .fetchUserPosts */ .bg)(userId, pageParam);
    }, {
        refetchOnWindowFocus: "always"
    });
    var optimistic = (0,_utils_query__WEBPACK_IMPORTED_MODULE_15__/* .useOptimisticUpdate */ .p7)();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(_api_community__WEBPACK_IMPORTED_MODULE_10__/* .togglePostLike */ ._P), toggleLike = ref1.mutate;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(postId) {
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_10__/* .deleteMyCommunityPost */ .VH)(postId);
    }), removePost = ref2.mutate;
    (0,_hooks_useScrollPosition__WEBPACK_IMPORTED_MODULE_4__/* .useScrollPosition */ .R)("userPostList:".concat(userId));
    var likePost = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(post) {
        toggleLike(post.id, {
            onSuccess: function(param) {
                var isLiked = param.isLiked;
                optimistic.update(queryKey, function(post) {
                    return _objectSpreadProps(_objectSpread({}, post), {
                        isLiked: isLiked,
                        likeCount: post.likeCount + (isLiked ? 1 : -1)
                    });
                }, {
                    id: post.id
                });
            }
        });
    }, []);
    var pollVote = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(post) {
        optimistic.update(queryKey, function(p) {
            return _objectSpreadProps(_objectSpread({}, p), {
                poll: post.poll
            });
        }, {
            id: post.id
        });
        var feedQueries = queryClient.getQueriesData([
            "communityFeed"
        ]);
        feedQueries.forEach(function(param) {
            var _param = _slicedToArray(param, 1), key = _param[0];
            optimistic.update(key, function(p) {
                return _objectSpreadProps(_objectSpread({}, p), {
                    poll: post.poll
                });
            }, {
                id: post.id
            });
        });
        queryClient.invalidateQueries([
            "communityFeed"
        ]);
        queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.FOLLOWING.FEED */ .U7.FOLLOWING.FEED);
        queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_11__/* .QUERY_KEYS.POST.ONE */ .U7.POST.ONE(post.id));
    }, []);
    var handleNavigatePostCreate = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
            return router.push("/feeds/posts/create");
        }
        web.openPage("/feeds/posts/create");
    };
    var handleNavigatePostDetail = function(id) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
            return router.push("/feeds/posts/".concat(id));
        }
        web.openPage("/feeds/posts/".concat(id));
    };
    var handleTagClick = function(tag) {
        router.push("/feeds".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
            tag: tag
        })));
    };
    var handleDeletePost = function(id) {
        if (confirm(t("정말 게시글을 삭제하시겠습니까?"))) {
            removePost(id, {
                onSuccess: function() {
                    return queryClient.invalidateQueries(queryKey);
                }
            });
        }
    };
    var handleActionSheet = function(value, id) {
        switch(value){
            case "modify":
                if (platform === _constants__WEBPACK_IMPORTED_MODULE_11__/* .Platform.web */ .t4.web) {
                    return router.push("/feeds/posts/create/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                        postId: id
                    })));
                }
                web.openPage("/feeds/posts/create/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                    postId: id
                })));
                break;
            case "delete":
                handleDeletePost(id);
                break;
            case "report":
                router.push("/report".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_14__/* .toQueryString */ .UK)({
                    objectType: _constants__WEBPACK_IMPORTED_MODULE_11__/* .ReportObjectType.community */ .LB.community,
                    objectId: id
                })));
                break;
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
        children: [
            isMyPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                css: writeButtonCSS,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_6__/* .DecoratedButton */ .b, {
                    css: userButtonCSS,
                    decoration: profileBtnDecoration,
                    onClick: handleNavigatePostCreate,
                    children: "새로운 게시글 쓰기"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Pagination__WEBPACK_IMPORTED_MODULE_8__/* .PaginationIterator */ .gt, {
                name: "user-post-list",
                query: query,
                border: true,
                children: function(item) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        onClick: function() {
                            return handleNavigatePostDetail(item.id);
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_Post__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, item), {
                            clip: true,
                            onLike: likePost,
                            onPollVote: pollVote,
                            isMyPage: isMyPage,
                            handleActionSheet: handleActionSheet,
                            onTagClick: handleTagClick
                        }))
                    });
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                query: query,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
                    children: t("작성한 게시글이 없습니다.")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PostList);


/***/ }),

/***/ 75872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _userId_; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useUserQuery.ts
var useUserQuery = __webpack_require__(75319);
// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/characters/CharacterCardList.tsx + 6 modules
var CharacterCardList = __webpack_require__(38662);
// EXTERNAL MODULE: ./components/common/ActionSheet.tsx
var ActionSheet = __webpack_require__(83898);
// EXTERNAL MODULE: ./components/common/Loading.tsx
var Loading = __webpack_require__(30208);
// EXTERNAL MODULE: ./components/common/Seo.tsx
var Seo = __webpack_require__(14054);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
// EXTERNAL MODULE: ./components/community/PostList.tsx
var PostList = __webpack_require__(959);
// EXTERNAL MODULE: ./components/layout/Header.tsx + 1 modules
var Header = __webpack_require__(58761);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/live/LiveSessionCard.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  margin: ",
        "px ",
        "px ",
        "px;\n  padding: ",
        "px;\n  border: 1px solid ",
        "33;\n  border-radius: ",
        "px;\n  background: ",
        ";\n  cursor: pointer;\n\n  .content {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .title {\n    display: block;\n    margin-top: ",
        "px;\n  }\n\n  .description {\n    display: block;\n    ",
        ";\n    color: ",
        ";\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: ",
        ";\n  font-weight: 700;\n\n  &::before {\n    content: '';\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var cardCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, theme.colors.red500, dist_esm/* Radius.medium */.wU.medium, theme.name === "dark" ? "linear-gradient(135deg, ".concat(theme.colors.red500, "1f, ").concat(theme.var.white, ")") : "linear-gradient(135deg, ".concat(theme.colors.red50, ", ").concat(theme.var.white, ")"), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var badgeCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), dist_esm/* Typography.body11 */.ZT.body11, theme.colors.red500, theme.colors.red500);
};
var LiveSessionCard = function(param) {
    var className = param.className, session = param.session;
    var openPageOrMove = (0,webview/* useWebView */.B9)().openPageOrMove;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
        type: "button",
        css: cardCSS,
        className: className,
        onClick: function() {
            return void openPageOrMove("/lives/".concat(session.id));
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                        css: badgeCSS,
                        children: "LIVE"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("strong", {
                        className: "title ellipsis",
                        children: session.title || "작가와 실시간으로 이야기해요"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                        className: "description",
                        children: "지금 라이브에 참여해보세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                icon: icon/* ArrowRight */.ol
            })
        ]
    });
};
/* harmony default export */ var live_LiveSessionCard = (LiveSessionCard);

// EXTERNAL MODULE: ./components/modal/NotificationModal.tsx
var NotificationModal = __webpack_require__(30738);
// EXTERNAL MODULE: ./components/common/FullscreenModal.tsx
var FullscreenModal = __webpack_require__(73686);
// EXTERNAL MODULE: ./components/common/RestrictionInfo.tsx
var RestrictionInfo = __webpack_require__(83170);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
;// CONCATENATED MODULE: ./components/modal/RestrictionInfoFullscreenModal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var RestrictionInfoFullscreenModal = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(FullscreenModal/* default */.Z, _objectSpreadProps(_objectSpread({
        name: "my-story-category-request"
    }, props), {
        title: t("정책 위반"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RestrictionInfo/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Push/* default */.Z, {
                size: Push/* PushSize.safe */.z.safe,
                bottom: true
            })
        ]
    }));
};
/* harmony default export */ var modal_RestrictionInfoFullscreenModal = (RestrictionInfoFullscreenModal);

// EXTERNAL MODULE: ./components/stories/StoryList.tsx
var StoryList = __webpack_require__(94942);
// EXTERNAL MODULE: ./components/user/UserInfo.tsx + 3 modules
var UserInfo = __webpack_require__(27425);
// EXTERNAL MODULE: ./api/live.ts
var live = __webpack_require__(25409);
// EXTERNAL MODULE: ./api/user.ts
var api_user = __webpack_require__(9622);
// EXTERNAL MODULE: ./constants/index.ts + 2 modules
var constants = __webpack_require__(45432);
// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/query.ts
var query = __webpack_require__(96261);
;// CONCATENATED MODULE: ./pages/users/[userId]/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _userId_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _userId_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _userId_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _userId_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _userId_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        _userId_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _userId_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _userId_templateObject() {
    var data = _userId_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin: 0 auto;\n\n  ",
        " {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n  ",
        " {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n"
    ]);
    _userId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

































var userDetailContainerCSS = (0,emotion_react_browser_esm.css)(_userId_templateObject(), css/* responsiveMaxWidth */.S8, css/* media.tablet */.BC.tablet, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.xlarge */.Ki.xlarge, css/* media.desktop */.BC.desktop, dist_esm/* Spacing.xxlarge */.Ki.xxlarge, dist_esm/* Spacing.xxlarge */.Ki.xxlarge);
var UserDetail = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var isCheming = (0,global/* useGlobalContext */.bN)().isCheming;
    var router = (0,next_router.useRouter)();
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var userId = (0,query/* getRouterQuery */.Fm)(router.query.userId);
    var useFetchUser = (0,useUserQuery/* useUserQuery */.b)().useFetchUser;
    var ref = useFetchUser(userId), user = ref.data;
    var ref1 = (0,es.useQuery)(constants/* QUERY_KEYS.LIVE.USER */.U7.LIVE.USER(userId), function() {
        return (0,live/* fetchUserLiveSessions */.kk)(userId);
    }, {
        enabled: constants/* LIVE_FEATURE_ENABLED */.sv && !!userId && !isCheming,
        suspense: false,
        retry: false,
        refetchOnWindowFocus: "always"
    }), liveSessions = ref1.data;
    var ref2 = (0,es.useQuery)([
        "userRestriction",
        userId
    ], function() {
        return (0,api_user/* fetchUserRestriction */.SW)(userId);
    }), restriction = ref2.data;
    (0,hook/* useScreen */.EV)("작가 상세");
    var ref3 = (0,hook/* useNotification */.lm)(constants/* SettingType.user */.Sd.user, userId, "followingUpdatePushStatus", user ? user.isFollowing : false), userSetting = ref3.data;
    var ref4;
    var notificationOption = (ref4 = userSetting === null || userSetting === void 0 ? void 0 : userSetting.setting["followingUpdatePushStatus"]) !== null && ref4 !== void 0 ? ref4 : "partial_enable";
    var tabs = (0,Tab/* useTab */.x)([
        {
            label: t("작품"),
            value: "stories"
        },
        {
            label: t("플레이"),
            value: "play"
        },
        {
            label: t("커뮤니티"),
            value: "community"
        }, 
    ], {
        replace: true
    });
    var activeTab = tabs.activeTab;
    var ref5 = _slicedToArray((0,useModal/* useModal */.d)("restriction-info-modal"), 2), isRestrictionInfoModalOpen = ref5[0], ref6 = ref5[1], openRestrictionInfoModal = ref6.open, closeRestrictionInfoModal = ref6.close;
    var ref7 = _slicedToArray((0,useModal/* useModal */.d)("notification-modal"), 2), isNotificationModalOpen = ref7[0], ref8 = ref7[1], openNotificationModal = ref8.open, closeNotificationModal = ref8.close;
    var actions = [
        {
            label: t("신고하기"),
            value: "report"
        },
        (user === null || user === void 0 ? void 0 : user.isBlocked) ? {
            label: t("차단 해제하기"),
            value: "unblock"
        } : {
            label: t("차단하기"),
            value: "block"
        }, 
    ];
    var optimistic = (0,query/* useOptimisticUpdate */.p7)();
    var ref9 = (0,es.useMutation)(api_user/* postToggleBlockUser */.rX), toggleBlockUser = ref9.mutate;
    var handleAction = (0,react.useCallback)(function(value) {
        switch(value){
            case "report":
                router.push("/report".concat((0,misc/* toQueryString */.UK)({
                    objectType: constants/* ReportObjectType.user */.LB.user,
                    objectId: userId
                })));
                break;
            case "block":
            case "unblock":
                toggleBlockUser(userId, {
                    onSuccess: function() {
                        optimistic.update(constants/* QUERY_KEYS.USER.ONE */.U7.USER.ONE(userId), function(user) {
                            return _userId_objectSpreadProps(_userId_objectSpread({}, user), {
                                isBlocked: !user.isBlocked
                            });
                        });
                    }
                });
                break;
            default:
                break;
        }
    }, [
        optimistic,
        router,
        toggleBlockUser,
        userId
    ]);
    var _obj;
    var restrictionIcons = (_obj = {}, _userId_defineProperty(_obj, constants/* RestrictionStatus.normal */.sM.normal, icon/* Face1 */.V6), _userId_defineProperty(_obj, constants/* RestrictionStatus.caution */.sM.caution, icon/* Face2 */.JY), _userId_defineProperty(_obj, constants/* RestrictionStatus.warn1 */.sM.warn1, icon/* Face3 */.G_), _userId_defineProperty(_obj, constants/* RestrictionStatus.warn2 */.sM.warn2, icon/* Face4 */.rR), _userId_defineProperty(_obj, constants/* RestrictionStatus.warn3 */.sM.warn3, icon/* Face5 */.HB), _userId_defineProperty(_obj, constants/* RestrictionStatus.warn4 */.sM.warn4, icon/* Face6 */.vM), _obj);
    var notificationIconMapper = {
        enable: icon/* BellFill */.pk,
        disable: icon/* BellStroke */.ir,
        partial_enable: icon/* Bell */.Uo,
        default: icon/* Bell */.Uo
    };
    var isNotificationDisabled = notificationOption === "default" || notificationOption === "disable";
    var ref10;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        css: userDetailContainerCSS,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Seo/* default */.Z, {
                title: user === null || user === void 0 ? void 0 : user.nickname
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Header/* default */.Z, {
                right: function(color) {
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            (restriction === null || restriction === void 0 ? void 0 : restriction.status) !== constants/* RestrictionStatus.exception */.sM.exception && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                className: "icon-btn",
                                onClick: openRestrictionInfoModal,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: restrictionIcons[(ref10 = restriction === null || restriction === void 0 ? void 0 : restriction.status) !== null && ref10 !== void 0 ? ref10 : constants/* RestrictionStatus.normal */.sM.normal],
                                    color: color
                                })
                            }),
                            (user === null || user === void 0 ? void 0 : user.isFollowing) && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                className: "icon-btn",
                                onClick: openNotificationModal,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                    icon: notificationIconMapper[notificationOption],
                                    color: isNotificationDisabled ? color : theme.colors.yellow500
                                })
                            }),
                            !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ActionSheet/* default */.Z, {
                                name: "user-action",
                                options: actions,
                                onSelect: handleAction,
                                children: function(open) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                        className: "icon-btn",
                                        onClick: open,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                            icon: icon/* VerticalEllipsis */.oR,
                                            color: color
                                        })
                                    });
                                }
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(UserInfo/* default */.Z, {
                userId: userId
            }),
            constants/* LIVE_FEATURE_ENABLED */.sv && (liveSessions === null || liveSessions === void 0 ? void 0 : liveSessions[0]) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(live_LiveSessionCard, {
                session: liveSessions[0]
            }),
            !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, _userId_objectSpreadProps(_userId_objectSpread({}, tabs), {
                fit: true
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                    push: true
                }),
                children: [
                    activeTab === "stories" && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryList/* default */.Z, {
                        userId: userId
                    }),
                    activeTab === "play" && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterCardList["default"], {
                        userId: userId,
                        isMyPage: false
                    }),
                    activeTab === "community" && !isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PostList["default"], {
                        userId: userId
                    }),
                    isCheming && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterCardList["default"], {
                        userId: userId,
                        isMyPage: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_RestrictionInfoFullscreenModal, {
                open: isRestrictionInfoModalOpen,
                onClose: closeRestrictionInfoModal
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NotificationModal["default"], {
                name: "notification-modal",
                open: isNotificationModalOpen,
                objectType: constants/* SettingType.user */.Sd.user,
                objectId: userId,
                settingKey: "followingUpdatePushStatus",
                onClose: closeNotificationModal,
                notificationOption: notificationOption
            })
        ]
    });
};
var UserDetailPage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
            fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Loading/* default */.ZP, {
                center: true
            }),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SafeArea/* default */.Z, {
                bottom: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(UserDetail, {})
            })
        })
    });
};
/* harmony default export */ var _userId_ = ((0,auth/* withAuth */.QO)(UserDetailPage, {
    isSignInRequired: false
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [496,5277,4798,741,3127,3814,1385,684,3215,3468,738,5904,8662,9774,2888,179], function() { return __webpack_exec__(11917); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);